import { TextInput } from 'components/formFields/TextInput';
import LocationSelector from 'components/LocationSelector/LocationSelector';
import { FormSingleSelectCustomField } from 'components/pages/jobApplication/CustomElementForm/CustomFormFields/FormSingleSelectCustomField';
import { MatchingProcessDeleteIcon } from '../../MatchingProcessDeleteIcon';
import { CheckboxInput } from 'components/formFields/CheckboxInput';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type menuOptionsInner = {
  label: string;
  value: number | string;
}[];

type ExperienceRowProps = {
  rowNumber: number;
  remove: <T>(index: number) => T | undefined;
  menuOptions: {
    roleTitle: menuOptionsInner;
    roleLevel: menuOptionsInner;
    industries: menuOptionsInner;
    headcountValues: menuOptionsInner;
  };
  setFieldValue: (field: string, value: any, shouldValidate?: any) => void;
  location: string;
  values: any;
};

const ExperienceRow = ({
  rowNumber,
  remove,
  menuOptions,
  setFieldValue,
  location,
  values,
}: ExperienceRowProps) => {
  const { t } = useTranslation('Matching+Process', { i18n });
  const handleCurrentPositionSelection = (
    values: any,
    idx: number,
    e: any,
    setFieldValue: any
  ) => {
    if (e.target.checked === true) {
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== idx) {
          setFieldValue(`experience.${i}.isCurrentPosition`, false);
        }
      }
    }
  };

  return (
    <div className="MatchingProcessPageRow">
      <FormSingleSelectCustomField
        fieldName={`experience.${rowNumber}.roleTitle`}
        label={t('SSCandidate_Matching_Process_Role_Title')}
        options={menuOptions.roleTitle}
        useNumberForValue={true}
        showError={false}
      />

      <FormSingleSelectCustomField
        fieldName={`experience.${rowNumber}.roleLevel`}
        label={t('SSCandidate_Matching_Process_Role_Level')}
        options={menuOptions.roleLevel}
        useNumberForValue={true}
        showError={false}
      />
      <TextInput
        name={`experience.${rowNumber}.years`}
        label={t('SSCandidate_Matching_Process_Years_Of_Exp')}
        maxLength={20}
        noTouch={true}
        isNumber
        additionalClassName="ExperienceYear"
      />
      <FormSingleSelectCustomField
        fieldName={`experience.${rowNumber}.sectorID`}
        label={t('SSCandidate_Matching_Process_Industry')}
        options={menuOptions.industries}
        useNumberForValue={true}
        showError={false}
      />
      <TextInput
        name={`experience.${rowNumber}.companyName`}
        label={t('SSCandidate_Matching_Process_Company_Name')}
        maxLength={20}
        noTouch={true}
      />
      <FormSingleSelectCustomField
        fieldName={`experience.${rowNumber}.companyHeadcount`}
        label={t('SSCandidate_Matching_Process_Company_Headcount')}
        options={menuOptions.headcountValues}
        useNumberForValue={true}
        showError={false}
      />

      <div className="FormBox FormSideBySide">
        <div className="FormLabel">Location</div>
        <LocationSelector
          locationChoice={location}
          updateLocation={(location, longitude, latitude) => {
            setFieldValue(`experience.${rowNumber}.location`, location);
            setFieldValue(`experience.${rowNumber}.longitude`, longitude);
            setFieldValue(`experience.${rowNumber}.latitude`, latitude);
          }}
          readOnly={false}
          push={() => {}}
        />
      </div>

      <CheckboxInput
        label={t('SSCandidate_Matching_Process_Label_Current_Position')}
        name={`experience.${rowNumber}.isCurrentPosition`}
        className="ExperienceCheckboxInput"
        isBordered={true}
        onClick={(e: any) =>
          handleCurrentPositionSelection(
            values.experience,
            rowNumber,
            e,
            setFieldValue
          )
        }
      />

      <MatchingProcessDeleteIcon
        onClick={() => {
          remove(rowNumber);
        }}
      />
    </div>
  );
};

export default ExperienceRow;
